import React from "react";

/**
 * Minimal class-based error boundary. Catches render-time errors in any
 * subtree and shows an inline retry card instead of blanking the page.
 *
 * Usage:
 *   <ErrorBoundary label="Recent leads">
 *     <RecentLeads />
 *   </ErrorBoundary>
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error(`[ErrorBoundary:${this.props.label || "section"}]`, error, info?.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div
        data-testid={`error-boundary-${(this.props.label || "section").toLowerCase().replace(/\s+/g, "-")}`}
        style={{
          border: "1px solid var(--scw-line)",
          padding: 20,
          background: "#fcf8f4",
          color: "#5C5C5C",
          fontSize: 13,
        }}
      >
        <p className="scw-eyebrow" style={{ marginBottom: 6, color: "#a13b3b" }}>
          Couldn{"\u2019"}t load {this.props.label || "this section"}
        </p>
        <p style={{ margin: "0 0 12px 0" }}>
          {String(this.state.error?.message || this.state.error || "Unknown error")}
        </p>
        <button
          type="button"
          className="scw-btn scw-btn-ghost"
          style={{ padding: "6px 14px" }}
          onClick={this.reset}
        >
          Retry
        </button>
      </div>
    );
  }
}
